import type { SupportAgentTicketCountMap } from '../../../queries/Support/useSupportAgentTicketCounts';
import { agentTicketCountTitle, formatAgentTicketCount } from './inboxFilters';

/** The count as a Select hint, with hover text saying what it counts; nothing until the counts load. */
export function agentTicketCountHint(agentTicketCounts: SupportAgentTicketCountMap | undefined, agentId: string) {
	const count = formatAgentTicketCount(agentTicketCounts, agentId);
	return count === undefined ? undefined : <span title={agentTicketCountTitle(agentId)}>{count}</span>;
}
